import React from 'react';

import plate from '../../../images/plate.svg';

import { FOHImage } from '../../ingredients';

export const FOHPlateIcon = () => (
  <FOHImage source={{ uri: plate }} style={{ width: 104, height: 104 }} />
);
